export default "__VITE_ASSET__D2WtaPww__"